import React from "react";
import { v4 as uuidv4 } from "uuid";
import Toast from "carbon-react/lib/components/toast";

const toastType = {
  success: "success",
  warning: "warning",
  error: "error"
};

const createNewToast = (message, type) => {
  return {
    id: uuidv4(),
    type: type,
    message: message
  };
};

const toastReducer = (state, action) => {
  switch (action.type) {
    case "ADD_TOAST":
      return [...state, action.toast];
    case "REMOVE_TOAST":
      const idx = state.findIndex(toast => toast.id === action.toast.id);
      if (idx >= 0) state.splice(idx, 1);
      return [...state];
    default:
      return state;
  }
};

const Toaster = ({ toasts, onDismissToast }) => {
  const renderToasts = toastType => {
    return (
      <>
        {toasts && toasts.length > 0
          ? toasts
              .filter(toast => toast.type === toastType)
              .map(toast => {
                return (
                  <Toast
                    key={`toast${toast.id}`}
                    open={true}
                    as={toastType}
                    onDismiss={() => onDismissToast(toast)}
                  >
                    {toast.message}
                  </Toast>
                );
              })
          : null}
      </>
    );
  };

  return (
    <>
      {renderToasts(toastType.success)}
      {renderToasts(toastType.warning)}
      {renderToasts(toastType.error)}
    </>
  );
};

export { Toaster, toastType, createNewToast, toastReducer };
